<script>
	import { geocoder } from './../geocoder.js';
  import {crosswalk, geocoderResult, household, laCounty, more} from '../stores'
  import { onMount } from 'svelte';
  import InfoBox from './InfoBox.svelte';
  import Error from './Error.svelte';
  import { hslide } from '../utils/hslide.js';
  
  import {apdate} from 'journalize';
  import { __ } from '../utils/i18n';

onMount(() => {
    let placeholderText = __("Enter a home address in L.A. County.");
  
    geocoder.addTo('#geocoder')
    geocoder.setPlaceholder(placeholderText);


    let submitButton = document.querySelector('button#submit-button');
    submitButton.disabled = true;

    geocoder.on('result', function (e) {
      submitButton.disabled = false;
      geocoderResult.set(e.result); 
    });
    geocoder.on('clear', function (e) {
      submitButton.disabled = true;
    });

    let ads = document.querySelector('aside.advertisement')
    ads.classList.add('hidden');

});



let date = window.PUBDATE.replace(/-/g,'/');
let type;

let lede = "Navigating local power structures is complicated. We’ll help you understand how government handles the issues that matter to you, and how to get stuff done in your neighborhood and beyond."

</script>

    <p>
    {__(lede)}
    </p>
    <div class="search-wrapper">
        <p>
            {__("To get started, enter your address.")}
        </p>
        <div id="geocoder" class="geocoder" class:error="{!$household || !$laCounty}"></div>

        {#if !$household }
            <Error type="wrongAd"/>
        {:else if !$laCounty}
            <Error type="notLAC"/>
        {/if}
        
        <div class="">
            <a 
              class="note-link" 
              tabindex="0" 
              on:click={()=>$more=!$more} 
              on:keydown={(e) => e.key === "Enter" ? $more=!$more : null}>
              {__("Questions?")}
            </a>
            |
            <a 
              class="note-link" 
              tabindex="0" 
              href={__("https://www.latimes.com/projects/community-civic-engagement-government-participation/es/")}>
              {__("Leer en español")}
            </a>
        </div>
    </div>


{#if $more }
    <InfoBox />
{/if}







